import React from 'react';
import FormContainer from '../../../../Components/Form/FormContainer';
import InputField from '../../../../Components/Form/components/InputField';

const PolandAddressContainer: React.FC = () => {
	return (
		<FormContainer name={'address'}>
			<div className='row mb-3'>
				<div className='col-lg-6 col-12'>
					<InputField
						name='street'
						label='component.polandAddressContainer.street'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='descriptiveNumber'
						label='component.polandAddressContainer.descriptiveNumber'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='guideNumber'
						label='component.polandAddressContainer.guideNumber'
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-lg-6 col-12'>
					<InputField
						name='city'
						label='component.polandAddressContainer.city'
						isRequired
					/>
				</div>
				<div className='col-lg-3 col-12'>
					<InputField
						name='postCode'
						label='component.polandAddressContainer.postCode'
						isRequired
					/>
				</div>
			</div>
		</FormContainer>
	);
};

export default PolandAddressContainer;
